export default "__VITE_ASSET__CB0rEisl__"